import { Link } from 'react-router-dom'
import { PiCopy, PiTrash } from 'react-icons/pi'
import { ViewConfig } from '../view-config'
import { CardActions } from './CardActions'
import { defaultReportIcon, REPORT_ICONS } from './reportIcons'

/** Shared library-card chrome (ReportCard + DashboardCard). */
export const LIBRARY_CARD_CLASS =
  'flex flex-col gap-2 p-4 bg-surface rounded-lg border border-line hover:border-brand-active transition-colors h-full'

export function ReportCard({
  view,
  onDelete,
  onDuplicate,
}: {
  view: ViewConfig
  /** Present only for saved views. */
  onDelete?: () => void
  /** Clone into "Your Views"; offered on shipped templates and saved views alike. */
  onDuplicate?: () => void
}) {
  const Icon = REPORT_ICONS[view.icon ?? defaultReportIcon(view)]
  return (
    <div className="relative group">
      <Link to={`/reporting/${view.id}`} className={LIBRARY_CARD_CLASS}>
        <div className="size-9 rounded-lg bg-brand-active/10 flex items-center justify-center text-brand-active">
          <Icon size={18} />
        </div>
        <div className="font-semibold text-fg">{view.name}</div>
        <div className="text-sm text-fg-secondary">{view.description}</div>
      </Link>
      <CardActions
        actions={[
          onDuplicate && {
            label: `Duplicate ${view.name}`,
            icon: PiCopy,
            onClick: onDuplicate,
          },
          onDelete && {
            label: `Delete ${view.name}`,
            icon: PiTrash,
            onClick: onDelete,
          },
        ]}
      />
    </div>
  )
}
